export default Object.freeze({
  Nuevo: 1,
  Aprobado: 2,
  Denegado: 3,
  AprobadoModificado: 4,
  Sometido: 5,
  ProcesoCompletado: 6,
  SolicitudRechazada: 7,
  CompletadoPendientedeAprobacion: 8,
  DevueltoAProveedor: 9,
  ExcluidoPorEstrategia: 10,
  ExcluidoPorEgreso: 11,
  ExcluidoPorAltaServicio: 12,
  SolicitudCompletada: 13,
  EnProcesoDiscusion: 14,
});
